export default __webpack_public_path__ + "static/media/registrationImage.fcb24f81.png";